import React, {Component} from 'react';
import 'react-tabs/style/react-tabs.css';
import {Editors, Formatters} from '../../react-data-grid-addons/dist/react-data-grid-addons.min.js';
import DialogStyles from '../ModalDialog/DialogStyles'
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import objeler from '../objeler.js';
import {withAlert} from '../../react-alert-master/src'
import {Col, Container, Row} from 'react-bootstrap';
import '../../components/Properties/modal.css'
import Loader from '../../react-fullpage-custom-loader/dist/index'

const {DropDownEditor, CheckboxEditor} = Editors;
const {DropDownFormatter} = Formatters;
const titleTypes = [
    {id: 'String', value: 'String', text: 'String', title: 'String'},
    {id: 'Integer', value: 'Integer', text: 'Integer', title: 'Integer'},
    {id: 'DateTime', value: 'DateTime', text: 'DateTime', title: 'DateTime'},
];
const TitleTypesEditor = <DropDownEditor options={titleTypes} style={{fontSize: '10px'}}
/>;
const TitleTypesFormatter = <DropDownFormatter options={titleTypes} style={{fontSize: '10px'}}/>;
const formatStyle = {
    display: "block",
    marginLeft: 0,
    width: "460px",
    height: "200px",
    zIndex: "0",
    fontSize: "14px",
    fontFamily: 'Raleway, Arial'
    , overflow: 'hidden'
};
const tbStyle = {
    display: "block",
    marginLeft: 0,
    width: "80px",
    height: "22px",
    zIndex: "0",
    fontSize: "14px",
    fontFamily: 'Raleway, Arial'
    , overflow: 'hidden'
    , textTransform: 'uppercase'
};
const comboStyle = {
    display: "block",
    width: "100%",
    height: "25px",
    zIndex: "0",
    vAlign: "middle",
    fontSize: "14px",
    fontFamily: 'Raleway, Arial'
    , overflow: 'hidden'
};
const dataTypeItems = {
    "values": [
        {"name": "String", "value": "String"},
        {"name": "Integer", "value": "Integer"}
    ]
}
const columns = [
    {
        key: 'Name', name: 'Name', editable: true, width: 120, height: 23, draggable: false
    },
    {
        key: 'DataType', name: 'Data Type', editable: true, editor: TitleTypesEditor, formatter: TitleTypesFormatter,
        width: 110, height: 23, draggable: false
    }
];
const rows = [
    {Name: 'ID', DataType: 'System.Int32'}
];

class Connect extends Component {
    constructor(props) {
        super(props);
        this.rdChange = this.rdChange.bind(this)
        this.state = {
            server: '',
            port: '',
            sid: '',
            service: '',
            user: '',
            password: '',
            database: '',
            ShowLoaderCon: false,
            Success: false,
            Failed: false
        };
        objeler['buildOracleValues'] = {...objeler.buildOracle};
        console.log('objeler.buildOracleddddd', objeler.buildOracle)
        this.child = React.createRef();
    };

    componentWillMount() {
        this.setState({update: true});
    }

    componentWillUpdate() {
        if (this.state.update) {
            this.setState({dsTab: this.props.data, update: false});
        }
    }

    clearDataSource() {
        this.setState({dsTab: []});
    }

    componentDidMount() {
        if (objeler.buildOracleValues.dbtype == 'Oracle') {
            if (objeler.buildOracleValues.type == 1)
                document.getElementById("rdService").checked = true;
            else
                document.getElementById("rdSid").checked = true;
            this.setFocus();
        }
    }

    setFocus() {
        setTimeout(() => {
            try {
                this.child.select();
            } catch {
                try {
                    this.child.focus();
                } catch {
                }
            }
        }, 1);
    }

    rdChange(e) {
        objeler.buildOracleValues.type = e.target.value;
        this.setState({Success: false, Failed: false});
        console.log('rdChange', objeler.buildOracleValues.type)
    }

    async testConnection(e) {
        this.setState({Success: false, Failed: false});
        var conn = "";
        var provider = objeler.buildOracleValues.dbtype
        if (objeler.buildOracleValues.dbtype == "Oracle") {
            if (objeler.buildOracleValues.type == 0)
                conn = "Data Source=(DESCRIPTION=(ADDRESS=(PROTOCOL=TCP)(HOST = " + objeler.buildOracleValues.server + ")(PORT = " + objeler.buildOracleValues.port + "))(CONNECT_DATA=(SID = " + objeler.buildOracleValues.sid + ")));User Id=" + objeler.buildOracleValues.user + ";Password=" + objeler.buildOracleValues.password;
            else
                conn = "Data Source=(DESCRIPTION=(ADDRESS=(PROTOCOL=TCP)(HOST = " + objeler.buildOracleValues.server + ")(PORT = " + objeler.buildOracleValues.port + "))(CONNECT_DATA=(SERVER=dedicated) (SERVICE_NAME = " + objeler.buildOracleValues.sid + ")));User Id=" + objeler.buildOracleValues.user + ";Password=" + objeler.buildOracleValues.password;
        }
        if (objeler.buildOracleValues.dbtype == "PostgreSQL") {
            conn = "User ID=" + objeler.buildOracleValues.user + ";Password=" + objeler.buildOracleValues.password + ";Server=" + objeler.buildOracleValues.server + ";Port=" + objeler.buildOracleValues.port + ";Database=" + objeler.buildOracleValues.database + ";Integrated Security=true;Pooling=true;"
        }
        this.setState({ShowLoaderCon: true})
        console.log('AAA', objeler.buildOracleValues.dbtype)
        await this.props.checkdbOracle(conn, provider).then((response) => {
            this.setState({ShowLoaderCon: false})
            this.setState({Success: response, Failed: !response})
        }).catch((error) => {
            this.setState({ShowLoaderCon: false})
        });
    }

    render() {
        const {classes} = this.props;
        const divStyle = {
            fontSize: "14px",
            fontFamily: 'Raleway, Arial'
            , overflow: 'hidden'
            , width: '300px'
            , height: '240px'
        };
        const textStyle = {
            width: "110%",
            height: "25px",
        };
        return (
            <div style={divStyle}>
                <Container>
                    <Row>
                        <Col sm className="ColVAlignConnect">Server :</Col>
                        <Col sm className="ColVAlignConnect">
                            <textarea name="TextAreaText" id="TextAreaText"
                                      ref={abc => this.child = abc}
                                      defaultValue={objeler.buildOracleValues.server}
                                      onChange={(e) => {
                                          objeler.buildOracleValues.server = e.target.value;
                                          this.setState({Success: false, Failed: false});
                                      }}
                                      style={textStyle} rows="1" cols="20" spellCheck="false">
                            </textarea>
                        </Col>
                    </Row>
                    <Row><br></br></Row>
                    <Row>
                        <Col sm className="ColVAlignConnect">Port :</Col>
                        <Col sm className="ColVAlignConnect">
                            <textarea name="TextAreaText" id="TextAreaText"
                                      defaultValue={objeler.buildOracleValues.port}
                                      onChange={(e) => {
                                          objeler.buildOracleValues.port = e.target.value;
                                          this.setState({Success: false, Failed: false});
                                      }}
                                      style={textStyle} rows="1" cols="20" spellCheck="false">
                            </textarea>
                        </Col>
                    </Row>
                    <Row><br></br></Row>
                    {
                        (() => {
                            console.log('buildOracleValues', objeler.buildOracleValues)
                            switch (this.props.DbType) {
                                case 'PostgreSQL':
                                    return (
                                        <Row>
                                            <Col sm className="ColVAlignConnect">Database :
                                            </Col>
                                            <Col sm className="ColVAlignConnect">
                            <textarea name="TextAreaText" id="TextAreaText"
                                      defaultValue={objeler.buildOracleValues.database}
                                      onChange={(e) => {
                                          objeler.buildOracleValues.database = e.target.value;
                                          this.setState({Success: false, Failed: false});
                                      }}
                                      style={textStyle} rows="1" cols="20" spellCheck="false">
                            </textarea>
                                            </Col>
                                        </Row>
                                    )
                                case 'Oracle':
                                    return (
                                        <Row>
                                            <Col sm className="ColVAlignConnect">
                                                <input type="radio" id="rdSid" name="fav_language" value="0"
                                                       onChange={this.rdChange}
                                                />
                                                &nbsp;
                                                <span style={{width: '30px'}}>SID</span>
                                                &nbsp;&nbsp;
                                                <input type="radio" id="rdService" name="fav_language" value="1"
                                                       onChange={this.rdChange}
                                                />
                                                &nbsp;
                                                <span>Service</span>
                                            </Col>
                                            <Col sm className="ColVAlignConnect">
                          <textarea name="TextAreaText" id="TextAreaText"
                                    defaultValue={objeler.buildOracleValues.sid}
                                    onChange={(e) => {
                                        objeler.buildOracleValues.sid = e.target.value;
                                        this.setState({Success: false, Failed: false});
                                    }}
                                    style={textStyle} rows="1" cols="20" spellCheck="false">
                          </textarea>
                                            </Col>
                                        </Row>
                                    )
                            }
                        }).call(this)}
                    <Row><br></br></Row>
                    <Row>
                        <Col sm className="ColVAlignConnect">User :</Col>
                        <Col sm className="ColVAlignConnect">
                            <textarea name="TextAreaText" id="TextAreaText"
                                      defaultValue={objeler.buildOracleValues.user}
                                      onChange={(e) => {
                                          objeler.buildOracleValues.user = e.target.value;
                                          this.setState({Success: false, Failed: false});
                                      }}
                                      style={textStyle} rows="1" cols="20" spellCheck="false">
                            </textarea>
                        </Col>
                    </Row>
                    <Row><br></br></Row>
                    <Row>
                        <Col sm className="ColVAlignConnect">Password :</Col>
                        <Col sm className="ColVAlignConnect">
                            <input name="TextAreaText" id="TextAreaText"
                                   type="password"
                                   defaultValue={objeler.buildOracleValues.password}
                                   onChange={(e) => {
                                       objeler.buildOracleValues.password = e.target.value;
                                       this.setState({Success: false, Failed: false});
                                   }}
                                   style={textStyle} rows="1" cols="20" spellCheck="false">
                            </input>
                        </Col>
                    </Row>
                    <Row style={{height: '55px'}}>
                        <Col sm className="ColVAlignConnect">
                            <Button autoFocus onClick={e => this.testConnection(e)}
                                    className={classes.closeButton}
                                    disableRipple={true}
                                    disableTouchRipple={true}
                                    disabled={(this.state.ShowLoaderCon) ? "disabled" : ""}
                                    focusRipple={false}
                                    style={{
                                        whiteSpace: 'nowrap',
                                        width: 'auto',
                                        paddingLeft: '8px',
                                        paddingRight: '8px'
                                    }}
                            >
                                Test Connection
                            </Button>
                        </Col>
                        <Col sm className="ColVAlignConnect">
                            {this.state.Success && <span style={{
                                color: 'green',
                                alignItems: 'center',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                whiteSpace: 'nowrap',
                                padding: '2px 1px 0px 11px'
                            }}>
                                Succeded.</span>
                            }
                            {this.state.Failed && <span style={{
                                color: 'red',
                                alignItems: 'center',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                whiteSpace: 'nowrap',
                                padding: '2px 1px 0px 16px'
                            }}>
                                Failed.</span>
                            }
                            {this.state.ShowLoaderCon && <Loader
                                wrapperBackgroundColor={'transparent'}
                                fullScreen={false}
                                color={'rgba(75, 85, 99 )'}
                                textStyles={{
                                    color: 'red',
                                    fontSize: '22px',
                                    fontWeight: '500',
                                    textShadow: '3px 3px 6px rgb(0 0 0/26%),0 0 5px rgb(15 3 86/22%)'
                                }}
                                fadeIn={true}
                                width={'110px'}
                                height={'54%'}
                            />
                            }
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withAlert()(withStyles(DialogStyles)(Connect));